import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function helpsElementAnimations() {
  document.addEventListener('DOMContentLoaded', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const helpsRows = gsap.utils.toArray('.helps-pages__row');

    helpsRows.forEach((el) => {
      let fromX = 0;
      if (el.classList.contains('is-left')) fromX = -50;
      if (el.classList.contains('is-right')) fromX = 50;

      gsap.from(el, {
        x: fromX,
        autoAlpha: 0,
        duration: 0.8,
        ease: 'power2.out',
        clearProps: 'transform,opacity',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        }
      });
    });
  });
}